
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/useAuth';
import { supabase } from '@/lib/supabase';
import { getCustomerDisplayName } from '@/utils/customerDisplayHelpers';

export interface CustomerOption {
  id: string;
  name: string;
  last_name: string;
  customer_type: string;
  business_name: string | null;
  representative_first_name: string | null;
  representative_last_name: string | null;
}

export const useCustomers = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['customers', user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('customers')
        .select('id, name, last_name, customer_type, business_name, representative_first_name, representative_last_name');
      
      if (error) throw error;
      // Sort by display name alphabetically
      return (data || []).sort((a, b) => 
        getCustomerDisplayName(a).localeCompare(getCustomerDisplayName(b))
      ) as CustomerOption[];
    },
    enabled: !!user?.id,
  });
};
